var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "c-block-title",
    {
      staticClass: "custom-block-title",
      style: {
        width: _vm.width || (_vm.$screen.mobile ? "100%" : "22.5%"),
      },
      scopedSlots: _vm._u([
        {
          key: "background",
          fn: function () {
            return [
              _c("c-picture", {
                attrs: {
                  src: require("@/assets/images/block_title_background_light.png"),
                  width: "100%",
                  ratio: "432:128",
                },
              }),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm.title
        ? _c("div", { staticClass: "custom-block-title__content" }, [
            _c("span", { staticClass: "custom-block-title__content__text" }, [
              _vm._v(_vm._s(_vm.title)),
            ]),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }